import { tgxApi } from "../../../app/tgxApi";
import { getAuthorizationHeader, handleQueryError, handleQueryErrorAndSuccess } from "../../../helpers/utils/RtkQueryUtils";
import { serialize } from "../../../helpers/utils/Utils";

export const tenantApi = tgxApi.injectEndpoints({
    endpoints: (build) => ({

        searchTenants: build.query({
            query: (query) => {
                return {
                    url: `/ajax/tenants/search?${serialize(query)}`,
                    method: 'GET',
                    headers: getAuthorizationHeader(),
                };
            },
            providesTags: ["tenants"],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryError(queryFulfilled)
            },
        }),
        getAllTenants: build.query({
            query: () => {
                return {
                    url: `/ajax/tenant`,
                    method: 'GET',
                    headers: getAuthorizationHeader(),
                };
            },
            providesTags: ["tenantsList"],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryError(queryFulfilled)
            },
        }),

        getTenantById: build.query({
            query: (id) => {
                return {
                    url: `/ajax/tenants/${id}`,
                    method: 'GET',
                    headers: getAuthorizationHeader(),
                };
            },
            providesTags: ["getTenantById"],
            async onQueryStarted(_, { queryFulfilled }) {
                await handleQueryError(queryFulfilled)
            },
        }),
        getTenantByName: build.query({
            query: (name) => {
                return {
                    url: `/ajax/tenants/name/${name}`,
                    method: 'GET',
                    headers: getAuthorizationHeader(),
                };
            },
            providesTags: ["getTenantByName"],
            async onQueryStarted(_, { queryFulfilled }) {
                await handleQueryError(queryFulfilled)
            },
        }),

        getTenantByUrl: build.query({
            query: (url) => {
                return {
                    url: `/ajax/tenants/name/${url}`,
                    method: 'GET',
                    headers: {
                        'X-Tenant-Url': url
                    },
                    credentials: "omit"
                };
            },
            providesTags: ["getTenantByUrl"],
            async onQueryStarted(_, { queryFulfilled }) {
                await handleQueryError(queryFulfilled);
            },
        }),


        updateTenant: build.mutation({
            query: ({ id, requestBody }) => {
                return {
                    url: `/ajax/update/tenant/${id}`,
                    method: 'PUT',
                    headers: getAuthorizationHeader(),
                    body: requestBody
                };
            },
            invalidatesTags: ["tenants"],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryErrorAndSuccess(queryFulfilled, "Updated", "Tenant")
            },
        }),

        updateTenantLogo: build.mutation({
            query: ({ id, logo, icon }) => {
                let data = new FormData();
                data.append("file", logo);
                data.append("icon", icon);
                return {
                    url: `/ajax/upload/tenant-assets/${id}`,
                    method: 'POST',
                    headers: getAuthorizationHeader(),
                    body: data
                };
            },
            invalidatesTags: ["tenants", "baseUrl"],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryError(queryFulfilled)
            },
        }),

        createTenant: build.mutation({
            query: ({ id, logo, icon }) => {
                let data = new FormData();
                data.append("file", logo);
                data.append("icon", icon);
                return {
                    url: `/ajax/upload/tenant-logo/${id}`,
                    method: 'Post',
                    headers: getAuthorizationHeader(),
                    body: data
                };
            },
            invalidatesTags: ["tenants"],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryError(queryFulfilled)
            },
        }),
    })
})

export const {
    useSearchTenantsQuery,
    useGetTenantByIdQuery,
    useGetTenantByUrlQuery,
    useGetAllTenantsQuery,
    useUpdateTenantMutation,
    useCreateTenantMutation,
    useUpdateTenantLogoMutation
} = tenantApi